import React, { FC } from 'react'
import { makeStyles } from '@mui/styles'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Theme } from '@mui/material/styles'

import { IColumns, IDataItem } from '../../pages/Finance/Finance/FinanceTableLists'
import { Loader } from '../Loader'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    margin: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '& thead tr': {
      height: '50px',
    },
    '& th': {
      color: theme.palette.primary.light,
      opacity: '0.6',
      fontWeight: 400,
      fontSize: 12,
      borderColor: 'rgba(233,236,239,0.38)',
      '&:not(:first-child)': {
        textAlign: ({ textAlign }: TableProps) => textAlign || 'right',
      },
    },
    '& tr': {
      height: '35px',
      '&:nth-child(even)': {
        // '&:nth-child(even):not(:last-child)': {
        backgroundColor: 'rgba(216,216,216,0.05)',
      },
    },
    '& td': {
      color: theme.palette.primary.light,
      border: 'none',
      padding: '10px 16px',
      '&:not(:first-child)': {
        textAlign: ({ textAlign }: TableProps) => textAlign || 'right',
      },
      '&.grey': {
        color: '#A5A5A5',
      },
      '&.green': {
        color: 'green',
      },
      '&.red': {
        color: 'red',
      },
      '&.orange': {
        color: 'orange',
      },
    },
  },
  total: {
    height: 55,
    '& td': {
      fontSize: 16,
    },
  },
  tableBody: {
    maxHeight: 200,
    overflowX: 'auto',
  },
  container: {
    maxHeight: '1000px',
  },
  pagination: {
    color: '#FFFFFF',
  },
  editIcon: {
    color: '#51e5a5',
  },
  infoIcon: {
    color: '#a8a9ac',
  },
  notFound: {
    backgroundColor: 'transparent !important',
    '& td': {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  },
}))

interface TableProps {
  columns: IColumns[]
  data?: IDataItem[]
  firstSum?: number
  secondSum?: number
  textAlign?: string
  loading?: boolean
}

export const TableSmall: FC<TableProps> = ({ columns, data, firstSum, secondSum, textAlign, loading }) => {
  const classes = useStyles({ columns, data, firstSum, secondSum, textAlign, loading })
  return (
    <>
      {loading && <Loader />}

      <Paper className={classes.root}>
        <TableContainer>
          <Table aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody className={classes.tableBody}>
              {data && data.length > 0 ? (
                <>
                  {data.map((row, idx) => {
                    return (
                      <TableRow hover role="checkbox" key={idx}>
                        {columns.map((column) => (
                          <TableCell key={column.id}>
                            {column.format && (typeof row[column.id] === 'number' || 'string')
                              ? column.format(row[column.id])
                              : row[column.id]}
                          </TableCell>
                        ))}
                      </TableRow>
                    )
                  })}

                  {firstSum !== undefined && secondSum !== undefined && (
                    <TableRow className={classes.total}>
                      <TableCell>Sub Total:</TableCell>
                      <TableCell>{firstSum.toFixed(3)}</TableCell>
                      {columns.length > 2 && <TableCell>{secondSum.toFixed(3)}</TableCell>}
                    </TableRow>
                  )}
                </>
              ) : (
                <TableRow className={classes.notFound}>
                  <TableCell colSpan={columns.length} align={'center'}>
                    {!loading && 'No results found'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )
}
